module.exports = __webpack_public_path__ + "static/img/st3.7cdb2d1d.png";